export default __webpack_public_path__ + "static/media/preference_branco.96aedbbd.svg";